import {useEffect, useState} from 'react'
import {Button, Form, Input, Modal, Radio} from 'antd'
import {Box, Flex, Text, Icon, Image} from '@chakra-ui/react'
import {useDispatch, useSelector} from 'react-redux'
import axios from 'axios'
import {REPORT_URL} from '@utils/Const'
import {checkDataForm, getUserId} from '@utils'
import {updateIsShowReportErrorForm} from '@redux/shared/shared'
import html2canvas from 'html2canvas-pro'

const axiosInstance = axios.create({
  baseURL: REPORT_URL,
})

const FormReportError = ({feature, screen}: {feature: string; screen: any}) => {
  const {isShowReportErrorForm} = useSelector((state: any) => state.shared)
  const [issue, setIssue] = useState<any>()
  const [screenshot, setScreenshot] = useState<any>()
  const [description, setDescription] = useState<any>('')
  const dispatch = useDispatch()

  useEffect(() => {
    return () => {
      dispatch(updateIsShowReportErrorForm(false))
    }
  }, [])

  useEffect(() => {
    if (isShowReportErrorForm) {
      const captureScreenshot = async () => {
        const canvas = await html2canvas(document.body)
        const image = canvas.toDataURL('image/png')
        setScreenshot(image)
      }
      captureScreenshot()
    }
  }, [isShowReportErrorForm])

  useEffect(() => {
    getIssueErrorForm()
  }, [feature, screen])

  const createFileFromImage = async (imageUrl: any, fileName: any) => {
    return fetch(imageUrl)
      .then(response => {
        return response.blob()
      })
      .then(blob => new File([blob], fileName, {type: 'image/png'}))
  }

  const getIssueErrorForm = async () => {
    const res = await axiosInstance.get(
      `/learnext/api/v1/tofu-open/issue?feature=${feature}&screen=${screen}&product=IELTS`,
    )
    if (res.data) {
      setIssue(res.data?.data?.issue)
    }
  }

  const handleCancel = () => {
    dispatch(updateIsShowReportErrorForm(false))
    setDescription('')
  }

  const onFinish = async (values: any) => {
    try {
      const userId = getUserId()
      const fileName = `user_${userId}_${Date.now()}.png`
      const file = await createFileFromImage(screenshot, fileName)
      let params = {
        issue_user: `{"product":"IELTS","description":"${
          values?.description?.replace(/\n/g, ' ') || ''
        }","screen":"${screen}","feature":"${feature}","issue":"${values?.issue}"}`,
        product: 'IELTS',
        file_evidence: file,
      }

      const formData = checkDataForm(params)
      const headers = {
        'Content-Type': 'multipart/form-data',
      }
      const res = await axiosInstance.post(
        '/learnext/api/v1/tofu-open/issue',
        formData,
        {
          headers,
        },
      )
    } catch (error) {
    } finally {
      handleCancel()
    }
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
  }

  return (
    <Modal
      styles={{
        content: {
          padding: '40px',
        },
      }}
      title={null}
      centered={true}
      open={isShowReportErrorForm}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose={true}>
      <Flex gap={'16px'} align={'start'}>
        <Icon w={'24px'} h="24px" viewBox="0 0 24 24">
          <path
            d="M12 0C5.37321 0 0 5.37321 0 12C0 18.6268 5.37321 24 12 24C18.6268 24 24 18.6268 24 12C24 5.37321 18.6268 0 12 0ZM12 21.9643C6.49821 21.9643 2.03571 17.5018 2.03571 12C2.03571 6.49821 6.49821 2.03571 12 2.03571C17.5018 2.03571 21.9643 6.49821 21.9643 12C21.9643 17.5018 17.5018 21.9643 12 21.9643Z"
            fill="#FAAD14"
            fillOpacity="0.85"
          />
          <path
            d="M10.7139 16.7143C10.7139 17.0553 10.8493 17.3823 11.0904 17.6234C11.3316 17.8645 11.6586 18 11.9996 18C12.3406 18 12.6676 17.8645 12.9087 17.6234C13.1498 17.3823 13.2853 17.0553 13.2853 16.7143C13.2853 16.3733 13.1498 16.0463 12.9087 15.8052C12.6676 15.564 12.3406 15.4286 11.9996 15.4286C11.6586 15.4286 11.3316 15.564 11.0904 15.8052C10.8493 16.0463 10.7139 16.3733 10.7139 16.7143ZM11.3567 13.7143H12.6424C12.7603 13.7143 12.8567 13.6179 12.8567 13.5V6.21429C12.8567 6.09643 12.7603 6 12.6424 6H11.3567C11.2389 6 11.1424 6.09643 11.1424 6.21429V13.5C11.1424 13.6179 11.2389 13.7143 11.3567 13.7143Z"
            fill="#FAAD14"
            fillOpacity="0.85"
          />
        </Icon>
        <Box>
          <Text fontSize={'16px'} fontWeight={600}>
            Bạn đang gặp lỗi, hãy cho chúng mình biết nhé!
          </Text>
        </Box>
      </Flex>
      <Form
        name="basic"
        style={{maxWidth: 500}}
        initialValues={{remember: true}}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off">
        <Form.Item
          name="issue"
          rules={[
            {required: true, message: 'Vui lòng chọn vấn đề bạn đang gặp'},
          ]}>
          <Radio.Group
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              marginTop: '24px',
            }}>
            {issue &&
              issue.map((item: any, index: any) => (
                <Radio key={index} value={item}>
                  {item}
                </Radio>
              ))}
          </Radio.Group>
        </Form.Item>
        <Text fontSize={'16px'} fontWeight={600} mb={'8px'}>
          Mô tả lỗi
        </Text>
        <Form.Item name={'description'}>
          <Box>
            <Input.TextArea
              placeholder="Bạn vui lòng mô tả chi tiết lỗi"
              maxLength={100}
              onChange={e => setDescription(e.target.value)}
              rows={4}
              style={{resize: 'none'}}
            />
            <Flex
              color={'#aaa'}
              fontWeight={300}
              justifyContent={'end'}
              letterSpacing={'1px'}>{`${description.length}/100`}</Flex>
          </Box>
        </Form.Item>
        <Form.Item style={{textAlign: 'center'}}>
          <Button
            type="primary"
            htmlType="submit"
            style={{width: '120px', borderRadius: '12px'}}>
            Gửi
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default FormReportError
